// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import("babel-polyfill")
import Vue from 'vue'

import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import axios from 'axios'
// import ECharts from 'vue-echarts'
import ECharts from 'vue-echarts/components/ECharts'
import hk from './hk'
import JJ from './JJ'
import ZG from './zhongguo'
import header from './router/httpHeard'
import global_ from './router/global'

import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/graph'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/title'


import 'echarts-wordcloud/dist/echarts-wordcloud.min'
import 'echarts-wordcloud/dist/echarts-wordcloud'

import 'element-ui/lib/theme-chalk/index.css'
import './css/common.css'
import './css/ownStyle.css'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(header)


router.beforeEach((to, from, next) => {
  Vue.http.headers.common['token'] = sessionStorage.getItem("xybdsToken");
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (JSON.parse(sessionStorage.getItem("userInfo"))) {  // 通过vuex state获取当前的token是否存在
      // console.dir(from.query)
      if(Object.keys(from.query).length === 0){//判断路由来源是否有query，处理不是目的跳转的情况
        next()
      }else{
        let redirect = from.query.redirect //如果来源路由有query
        if(to.path === redirect){//这行是解决next无限循环的问题
          next()
        }else{
          // Vue.http.headers.common['xybdsToken'] = sessionStorage.getItem("xybdsToken");
          next({path:redirect})//跳转到目的路由
        }
      }
    }
    else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })

    }
  }
  else {
    next();
  }
})

Vue.use(VueResource)

// Vue.http.options.xhr = { withCredentials: true }
// Vue.http.options.emulateJSON = true
// Vue.http.options.crossOrigin = true
// Vue.http.options.emulateHTTP = true
Vue.component('chart', ECharts)
ECharts.registerMap('HK', hk)
ECharts.registerMap('JJ', JJ)
ECharts.registerMap('ZG', ZG)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// Vue.http.interceptors.push((request) => {
//   request.headers.set('token', sessionStorage.getItem("xybdsToken")); //setting request.headers
//   // next((response) => {
//   //   return response
//   // })
//
// });



// WEBPACK FOOTER //
// ./src/main.js